// src/auth/AuthProvider.js
import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

const API_BASE =
  process.env.NODE_ENV === "development" ? "" : process.env.REACT_APP_API_BASE_URL || "";

const AuthCtx = createContext({
  user: null,
  loading: true,
  login: async () => {},
  logout: async () => {},
});

async function parseJsonSafe(response) {
  // Essaie de parser du JSON, sinon renvoie { raw: ... } pour diagnostic
  const ct = response.headers.get("content-type") || "";
  if (ct.includes("application/json")) {
    return response.json();
  }
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    return { raw: text };
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Au mount, tente de r�cup�rer la session
  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/api/auth/me`, {
          credentials: "include",
        });
        const d = await parseJsonSafe(r);
        setUser(d?.user || null);
      } catch (e) {
        // silencieux: pas de session
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function login(email, password) {
    const r = await fetch(`${API_BASE}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, password }),
    });

    const d = await parseJsonSafe(r);
    if (!r.ok) {
      const msg = d?.message || "Erreur de connexion";
      throw new Error(msg);
    }
    setUser(d.user);
  }

  async function logout() {
    try {
      await fetch(`${API_BASE}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
    } finally {
      setUser(null);
    }
  }

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useAuth() {
  return useContext(AuthCtx);
}
